// extracted by mini-css-extract-plugin
export default {"accordionButton":"_3GT5teiSHJEE7tNxszoZbk7WJoAoY2RMb+KiUAqAvlY=","icon":"qzyikeqwEe1k8RCsLt3WrgPOeAPcjZ6BzN37905Xmmc="};